import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import InputText from "../../../components/Input/InputText";
import ErrorText from "../../../components/Typography/ErrorText";
import { showNotification } from "../../common/headerSlice";
// import { addNewSpecialMessage } from "../specialMessageSlice";
import api from "../../../utils/axios";
import { triggerRefresh } from "../../../utils/refreshRegistry";

const INITIAL_SPECIAL_MEETING_OBJ = {
  name: "",
};

async function addSpecialMeeting(e) {
  try {
    const newSpecialMeeting = await api.post("api/special-meetings", e);
    return newSpecialMeeting;
  } catch (error) {
    console.error("Error adding special meeting:", error);
    throw error;
  }
}

function AddSpecialMeetingModalBody({ closeModal }) {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [specialMeetingObj, setSpecialMeetingObj] = useState(INITIAL_SPECIAL_MEETING_OBJ);
  const [saving, setSaving] = useState(false);

  const saveNewSpecialMeeting = async () => {
    if (specialMeetingObj.name.trim() === "")
      return setErrorMessage("Special Meeting Name is required!");

    setSaving(true);
    setErrorMessage("");

      // Create the meeting
      let newSpecialMeetingObj = {
        name: specialMeetingObj.name,
      };

    try {
      await addSpecialMeeting(newSpecialMeetingObj);
      // dispatch(addNewSpecialMessage({ newSpecialMessageObj }));
      dispatch(showNotification({ message: "New Special Meeting Added!", status: 1 }));
      closeModal();
      triggerRefresh("specialMeetings");
    } catch (error) {
      console.error("Error saving meeting:", error);
      const errorMsg =
        error.response?.data?.message ||
        "Failed to save meeting. Please try again.";
      setErrorMessage(errorMsg);
      dispatch(
        showNotification({
          message: errorMsg,
          status: 0,
        }),
      );
    } finally {
      setSaving(false);
    }
  };

  const updateFormValue = ({ updateType, value }) => {
    setErrorMessage("");
    setSpecialMeetingObj({ ...specialMeetingObj, [updateType]: value });
  };

  return (
    <>
      <InputText
        type="text"
        defaultValue={specialMeetingObj.name}
        updateType="name"
        containerStyle="mt-4"
        labelTitle="Special Meeting Name"
        updateFormValue={updateFormValue}
      />

      <ErrorText styleClass="mt-16">{errorMessage}</ErrorText>
      <div className="modal-action">
        <button className="btn btn-ghost" onClick={() => closeModal()}>
          Cancel
        </button>
        <button
          className="btn btn-primary px-6"
          onClick={() => saveNewSpecialMeeting()}
          disabled={saving}
        >
          {saving ? (
            <>
              <span className="loading loading-spinner loading-sm"></span>
              Saving...
            </>
          ) : (
            "Save"
          )}
        </button>
      </div>
    </>
  );
}

export default AddSpecialMeetingModalBody;

